import {notificationsStore} from "./notificationsStore";
import DOMPurify from "dompurify";
import {marked} from "marked";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	if (!("target" in node)) return;
	node.setAttribute("target", "_blank");
	node.setAttribute("rel", "noreferrer");
});

/** Parse and sanitize markdown */
export const markdown2Html = (input: string) => {
	try {
		const parsed = marked.parseInline(input, {async: false, breaks: true});
		const sanitized = DOMPurify.sanitize(parsed);
		return sanitized;
	} catch (error) {
		console.error("Error parsing/sanitizing markdown:", error);
		return "";
	}
};

/** Convert non-standard locales (xx_XX|en_INT) to BCP47 (xx-XX) or fallback to en-US */
export const toBCP47Locale = (locale: string) => {
	// pass valid BCP47 locales (eg de-AT)
	if (/^[a-z]{2}-[A-Z]{2}$/.test(locale)) return locale;

	// explicitly convert en_INT to en-US
	if (locale === "en_INT") return "en-US";

	// convert Trumpf-style (eg fr_FR to fr-FR)
	if (/^[a-z]{2}_[A-Z]{2}$/.test(locale)) return locale.replace("_", "-");

	// fallback to en-US for anything else
	if (notificationsStore.debugMode) console.warn(`Locale "${locale}" not supported. Falling back to "en-US".`);
	return "en-US";
};

/** Used to compare (settings store) state changes */
export const deepEquals = (a: unknown, b: unknown): boolean => {
	if (a === b) return true;
	if (typeof a !== typeof b) return false;
	if (a === null || b === null) return a === b;

	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) {
			if (!deepEquals(a[i], b[i])) return false;
		}

		return true;
	}

	if (typeof a === "object" && typeof b === "object") {
		const aKeys = Object.keys(a);
		const bKeys = Object.keys(b);
		if (aKeys.length !== bKeys.length) return false;
		aKeys.sort();
		bKeys.sort();
		for (let i = 0; i < aKeys.length; i++) {
			if (aKeys[i] !== bKeys[i]) return false;
			if (!deepEquals((a as Record<string, unknown>)[aKeys[i]], (b as Record<string, unknown>)[bKeys[i]])) return false;
		}
		return true;
	}

	return false;
};
